<template>
    <div>
        <div class="card border-radius-10">
            <div class="card-body">
                <div class="d-flex justify-content-center">
                    <vs-avatar size="100">
                        <template #text>
                            {{ user.name }}
                        </template>
                    </vs-avatar>
                </div>
                <div class="text-center">
                    <div class="mt-3">
                        <template v-if="loading.user">Loading...</template>
                        <template v-else>{{ user.name }}</template>
                    </div>
                </div>

                <div class="dropdown-divider"></div>

                <div class="mt-3">
                    <ul class="nav nav-tabs">
                        <li class="nav-item">
                            <a class="nav-link" :class="{'active' : tab == 'personal'}" href="javascript:void(0)" @click="tab = 'personal'">Personal</a>
                        </li>
                        <li class="nav-item">
                            <a class="nav-link" :class="{'active' : tab == 'password'}" href="javascript:void(0)" @click="tab = 'password'">Password</a>
                        </li>
                    </ul>

                    <div class="mt-3">
                        <personal v-if="tab == 'personal'" @resetDataAccount="getAccount"/>
                        <password v-else-if="tab == 'password'"/>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { usersCollection } from '@/helpers/firebase';
import accountHelper from '@/helpers/account';

export default {
    data() {
        return {
            tab: 'personal',
            user: {},
            loading: {
                user: true,
            },
            error: {
                user: false,
            }
        }
    },
    components: {
        personal: () => import("@/components/setting/personal"),
        password: () => import("@/components/setting/password")
    },
    methods: {
        getAccount() {
            this.loading.user = true;

            let user = accountHelper.getIdUser();
            if(user) {
                usersCollection.doc(user.email).get().then(doc => {
                    this.user = doc.data();
                    this.loading.user = false;
                }).catch(err => {
                    console.log('error get account', err);
                    this.error.user = true;
                    this.loading.user = false;
                });
            } else {
                this.loading.user = false;
                this.error.user = true;
            }
        }
    },
    mounted() {
        this.getAccount();
    }
}
</script>

<style scoped>
.border-radius-10 {
    border-radius: 10px !important;
}
</style>